import { GeneralLangFactory } from "@bokio/lang";

import * as styles from "./signAndPayHeader.scss";

export interface SignAndPayHeaderProps {
	showTitleAndBalance?: boolean;
	availableBalanceString?: string;
	onClose: () => void;
}

export const SignAndPayHeader = () => {
	const generalLang = GeneralLangFactory();
	// BBA multiple accounts refactoring:
	// Only used to go to BBA transactions list, will be refactored away in multiple accounts design.

	return (
		<div className={styles.container}>
			<div className={styles.header}>
				<div className={styles.title}>{generalLang.BBA_PaymentsToSign}</div>
			</div>
		</div>
	);
};
